import { render, staticRenderFns } from "./clzj.vue?vue&type=template&id=4f6487ae&scoped=true&"
import script from "./clzj.vue?vue&type=script&lang=js&"
export * from "./clzj.vue?vue&type=script&lang=js&"
import style0 from "./clzj.vue?vue&type=style&index=0&id=4f6487ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6487ae",
  null
  
)

export default component.exports